/*
 * QuestionnaireEditCode Messages
 *
 * This contains all the text for the QuestionnaireEditCode component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.QuestionnaireEditCode';

export default defineMessages({
  addFormula: {
    id: `${scope}.addFormula`,
    defaultMessage: 'Add your Formula\'s code here to check it',
  },
  validate: {
    id: `${scope}.validate`,
    defaultMessage: 'Validate',
  },
  formaulaIs: {
    id: `${scope}.formaulaIs`,
    defaultMessage: 'Formaula is',
  },
  valid: {
    id: `${scope}.valid`,
    defaultMessage: 'Valid',
  },
  invalid: {
    id: `${scope}.invalid`,
    defaultMessage: 'Invalid',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  scriptSaved: {
    id: `${scope}.scriptSaved`,
    defaultMessage: 'Script saved successfully',
  },
});
